module.exports = __webpack_public_path__ + "img/em.eeddccb5.png";